import React, { ReactNode, useEffect, useRef } from "react";
import DashboardTranslationStore from "./stores/dashboard-translations-store";


interface IProps {
    children?: ReactNode;
}

export const DashboardTranslationLocaleContext = React.createContext<typeof DashboardTranslationStore>({} as typeof DashboardTranslationStore);

const DashboardTranslationLocale = ({ children }: IProps) => {
    const storeRef = useRef(DashboardTranslationStore);
    const store = storeRef.current;

    useEffect(() => {
        store.load();
    }, [store]);
    
    return (
        <DashboardTranslationLocaleContext.Provider value={store}>
            {children}
        </DashboardTranslationLocaleContext.Provider>
    );
}

export default DashboardTranslationLocale;